

import React, { Component } from 'react';
import { getFromDrupalAPI } from '../../fetchJSON.js';
import { decode } from 'he';
import _ from 'lodash';


class ParentingArticle extends Component {
  constructor(props) {
    super(props);
    this.state = {
      article: null,
      articleID: this.props.match.params.nid
    }
  }

  componentWillMount() {
    var that = this;

    var articleLocation = 'all_parenting_articles_api?filters[nid]=' + this.state.articleID;
    getFromDrupalAPI(articleLocation, function (data) {
      that.setState({ article: data })
    });

  }


  render() {
    var blogArticle;
    if (this.state.article && this.state.article.length > 0) {
      blogArticle = _.map(this.state.article, (article) => {
        return (
          <div className="item" key={_.uniqueId()}>
            <div className="item-title">
              <h2>{decode(article.node_title)}</h2>
              <span className="label label-default light">{article.date}</span>
            </div>

            <div dangerouslySetInnerHTML={{ __html: decode(article.body) }} />

            <hr />
          </div>

        )
      });
    }
    else if (this.state.article) {
      blogArticle = <div>Sorry, that item could not be found. To view all of our available parenting articles please go to <a href="/ParentingArticles">this page.</a></div>;
    }
    else {
      blogArticle = <div></div>;
    }

    return (
      <section>
        <header id="page-title">
          <div className="container">
            <h1>Parenting Article</h1>
          </div>
        </header>
        <section className="container">

          {blogArticle}

        </section>
      </section>
    );
  }
}

export default ParentingArticle;
